const handleErr = (res: any) => {
  if (res.status === 'error') {
    if (res.message === 'jwt expired') {
      localStorage.removeItem('token');
      window.location.replace('/dashboard/login');
    }
  }
};

const getBeranda = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/beranda`);
    const resJson = await res.json();
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getTotalVisitor = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/visitor`
    );
    const resJson = await res.json();
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getTblTarif = async (
  limit: number,
  page: number,
  search: any,
  tahap: any = null
) => {
  try {
    let url = `${process.env.REACT_APP_URL}/api/jlp/beranda/tbl-tarif?limit=${limit}&page=${page}&search=${search}`;
    if (tahap) {
      url += `&tahap=${tahap}`;
    }
    const headers: any = {
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(url, {
      method: 'GET',
      headers,
    });
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postTblTarif = async (body: any) => {
  try {
    const headers: any = {
      Authorization: localStorage.getItem('token'),
      'Content-Type': 'application/json',
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/tbl-tarif`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const putTblTarif = async (id: any, body: any) => {
  try {
    const headers: any = {
      Authorization: localStorage.getItem('token'),
      'Content-Type': 'application/json',
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/tbl-tarif/${id}`,
      {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteTblTarif = async (id: string) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/tbl-tarif/${id}`,
      {
        method: 'DELETE',
        headers,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postVisitor = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/visitor`,
      {
        method: 'POST',
      }
    );
    const resJson = await res.json();
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getPageName = async (query: any) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/pages?page_name=${query}`
    );
    const resJson = await res.json();
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getContent = async (
  type: number,
  limit: number,
  page: number,
  search: string = ''
) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=${type}&limit=${limit}&page=${page}&search=${search}`
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getFormApp = async (
  type: number,
  limit: number,
  page: number,
  search: string = ''
) => {
  try {
    const headers: any = {
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/form-app?type=${type}&limit=${limit}&page=${page}&search=${search}`,
      { headers }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getImages = async (limit: number, page: number, search: string = '') => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/images?limit=${limit}&page=${page}&search=${search}`
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getContactUsInfo = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/contact-us/info`
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getContactUs = async (
  limit: number,
  page: number,
  search: string = ''
) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/contact-us?limit=${limit}&page=${page}&search=${search}`
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updateContent = async (id: string, body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/${id}`,
      {
        method: 'PUT',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updateContentTK = async (id: string, body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/tk/${id}`,
      {
        method: 'PUT',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updateContentGK = async (id: string, body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/gk/${id}`,
      {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updateContentMultiImg = async (id: string, body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/multi-img/${id}`,
      {
        method: 'PUT',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updateDewan = async (id: string, body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/dewan/${id}`,
      {
        method: 'PUT',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContent = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/content`, {
      method: 'POST',
      headers,
      body,
    });
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContentTK = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/content/tk`, {
      method: 'POST',
      headers,
      body,
    });
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContentGK = async (body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };

    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/content/gk`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContentMultiImg = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/multi-img`,
      {
        method: 'POST',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postFormApp = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/form-app`,
      {
        method: 'POST',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postDewan = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/dewan`,
      {
        method: 'POST',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postImage = async (body: any) => {
  try {
    const headers: any = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/images`,
      {
        method: 'POST',
        headers,
        body,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContactUs = async (body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/contact-us`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postContactUsInfo = async (body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/contact-us/info`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const postBeranda = async (body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/beranda`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteData = async (id: string, body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/${id}`,
      {
        method: 'DELETE',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteDataFormApp = async (id: string) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/form-app/${id}`,
      {
        method: 'DELETE',
        headers,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteDataTK = async (id: string) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/tk/type/${id}`,
      {
        method: 'DELETE',
        headers,
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteDataImgContent = async (id: string, body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/multi-img/${id}`,
      {
        method: 'DELETE',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const deleteContentTK = async (id: string, body: any) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token'),
    };
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/tk/${id}`,
      {
        method: 'DELETE',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    handleErr(resJson);
    return resJson;
  } catch (err) {
    throw err;
  }
};

const updatePasswordMobile = async (token: string, body: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
  try {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/mobile/account/confirm-reset-password/${token}`,
      {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      }
    );
    const resJson = await res.json();
    return resJson;
  } catch (err) {
    throw err;
  }
};

const getCctv = async (limit?: number, page?: number, search?: string) => {
  const headers: any = {
    Authorization: localStorage.getItem('token'),
  };
  let url = `${process.env.REACT_APP_URL}/api/jlp/cctv?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${search}`;
  }
  const res = await fetch(url, {
    method: 'GET',
    headers,
  });
  const resJson = await res.json();
  return resJson;
};

const getCctvTios = async () => {
  const headers: any = {
    Authorization: localStorage.getItem('token'),
  };
  const url = `${process.env.REACT_APP_URL}/api/jlp/cctv/all`;
  const res = await fetch(url, {
    method: 'GET',
    headers,
  });
  const resJson = await res.json();
  return resJson;
};

const putCctv = async (id: number, body: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
  const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/cctv/${id}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  });
  const resJson = await res.json();
  return resJson;
};

const postCctv = async (body: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
  const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/cctv`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const resJson = await res.json();
  return resJson;
};

const deleteCctv = async (id: number) => {
  const headers: any = {
    Authorization: localStorage.getItem('token'),
  };
  const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/cctv/${id}`, {
    method: 'DELETE',
    headers,
  });
  const resJson = await res.json();
  return resJson;
};

const putUserPassword = async (id: number, body: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
  const res = await fetch(
    `${process.env.REACT_APP_URL}/api/jlp/user/password/${id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    }
  );
  const resJson = await res.json();
  return resJson;
};

const putVideo = async (name: any, body: any) => {
  const headers: any = new Headers();
  headers.append('Authorization', localStorage.getItem('token'));
  const res = await fetch(
    `${process.env.REACT_APP_URL}/api/jlp/video/${name}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    }
  );
  const resJson = await res.json();
  return resJson;
};

const putLinkVideo = async (name: any, body: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
  const res = await fetch(
    `${process.env.REACT_APP_URL}/api/jlp/video/${name}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    }
  );
  const resJson = await res.json();
  return resJson;
};

export {
  getTotalVisitor,
  getBeranda,
  getFormApp,
  getPageName,
  getContent,
  getTblTarif,
  getImages,
  getContactUs,
  getContactUsInfo,
  getCctv,
  getCctvTios,
  updateContent,
  updateContentTK,
  updateContentGK,
  updateContentMultiImg,
  updateDewan,
  updatePasswordMobile,
  postVisitor,
  postContent,
  postContentTK,
  postContentGK,
  postContentMultiImg,
  postDewan,
  postFormApp,
  postImage,
  postContactUs,
  postContactUsInfo,
  postBeranda,
  postTblTarif,
  postCctv,
  putTblTarif,
  putCctv,
  putVideo,
  putLinkVideo,
  putUserPassword,
  deleteData,
  deleteDataFormApp,
  deleteDataTK,
  deleteContentTK,
  deleteDataImgContent,
  deleteTblTarif,
  deleteCctv,
};
